import {Component, OnInit, Output, Input, EventEmitter, ElementRef} from '@angular/core';
import { ApiService } from '../../../api/api.service';
import * as _ from 'lodash';

@Component({
    selector: 'app-casefilter',
    templateUrl: './casefilter.component.html',
    styleUrls: ['./casefilter.component.css'],
    standalone: false
})
export class CasefilterComponent implements OnInit {

  countries: any[] = [];
  sponsors: any[] = [];
  products: any[] = [];
  plans: any[] = [];
  providers: any[] = [];
  categories: any[] = [];
  services: any[] = [];
  doctors:any[] = [];
  tdServices: any;
  country_id: number;
  sponsor_id: number;
  provider_id: number;
  category_id: number;
  product_id: number;
  service_id: number;
  plan_id: number;
  doctor_id: number;
  user_id: number;
  tdService_id:number;
  styleFlag: boolean = false;
  graph_items: any = [];
  @Input() graph_id: any;
  @Output() filter = new EventEmitter<any>();

  constructor(private api: ApiService, public el: ElementRef) {

  }

  getGraph_item(items) {
    return items.some((item) => {
        return this.graph_items.indexOf(item) !== -1;
      });
  }

  ngOnInit() {
    this.api.countries.get().all().promise()
      .then(c => {
        this.countries = c.data;
      });

    if (!this.getGraph_item(['sales'])) {
      this.api.assistancecategories.get().all().promise()
      .then(ca => {
        this.categories = ca.data;
      });
    }

   

    this.tdServices = [
      {"id":5, "name":"video llamada"},
      {"id":6, "name":"chat"},
    ]
  }

  reset() {
    this.country_id = null;
    this.sponsor_id = null;
    this.category_id = null;
    this.product_id = null;
    this.service_id = null;
    this.provider_id = null;
    this.plan_id = null;
    this.sponsors = [];
    this.products = [];
    this.plans = [];
    this.providers = [];
    this.user_id = null;
  }

  onSelectCountry(country_id) {

    if (country_id === 'null') {
          this.country_id = null;
          this.sponsor_id = null;
          this.product_id = null;
          this.provider_id = null;
          this.plan_id = null;
          this.sponsors = [];
          this.products = [];
          this.providers = [];
          this.plans = [];
        }
        else {
          this.country_id = parseInt(country_id);
          this.api.sponsors.get(this.country_id).all().promise()
          .then(sponsors => {
            this.sponsors = sponsors;
          });
          let filter = {};
          if (this.getGraph_item(['survey'])) {
            filter = {'country_id': this.country_id};
          } else {
            filter = {'country_id': this.country_id,
              'sponsor_id': this.sponsor_id};
          }

          this.api.assistances.get().all().filter(filter).promise()
            .then(assistances => {
              this.products = assistances.data;
            });
        }
  }

  onSelectSponsor(sponsor_id) {

    if (sponsor_id === 'null') {
          this.sponsor_id = null;
        } else {
          this.sponsor_id = parseInt(sponsor_id);
          if (!this.getGraph_item(['survey'])) {
            const filter = {'country_id': this.country_id,
              'sponsor_id': this.sponsor_id};
            this.api.assistances.get().all().filter(filter).promise()
              .then(assistances => {
                this.products = assistances.data;
              });
          }
        }
  }

  onSelectProduct(product_id) {
   if (product_id !== 'null') {
      this.product_id = parseInt(product_id);
      if (!this.getGraph_item(['sales'])) {
          this.api.assistanceProviders.getbyassistance(this.product_id).all().promise()
          .then(item => {
            this.providers = item;
          });
      }

     const filter = {'assistance_id': this.product_id};
      this.api.assistanceplans.get().filter(filter).promise()
        .then(resp => {
          this.plans = resp.data;
        });

    } else {
      this.product_id = null;
      this.provider_id = null;
      this.plan_id = null;
      this.providers = [];
      this.plans = [];
    }
  }

  onSelectPlan(plan_id) {
    this.plan_id = parseInt(plan_id);
  }

  onSelectProvider(provider_id) {
    if (provider_id !== 'null') {
      this.provider_id = provider_id;

    } else {
      this.provider_id = null;
    }
  }

  onSelectCategory(category_id) {
    if (category_id !== 'null') {
      this.category_id = category_id;
      const filter = {'category_id': this.category_id};
      this.api.assistanceservices.get().filter(filter).all().promise()
      .then(s => {
        this.services = s.data;
      });
    } else {
      this.category_id = null;
      this.service_id = null;
      this.services = [];
    }
  }

  onSelectService(service_id) {
    if (service_id !== 'null') {
          this.service_id = service_id;
        } else {
          this.service_id = null;
        }
  }

  setFilter() {
    this.graph_items = [this.graph_id];
    this.styleFlag = true;
  }

  onCancel() {
    this.styleFlag = false;
  }
  onFilter() {
    let symbol: any = null;
    if (this.country_id)
      symbol = _.find(this.countries, p => p.id === this.country_id).currency_symbol;
    let param = {};
    if (this.getGraph_item(['sales'])) {
      param = {graph_id: this.graph_id, country: this.country_id, product: this.product_id,
      plan: this.plan_id, sponsor: this.sponsor_id};
    } else if (this.getGraph_item(['survey'])) {
      param = {graph_id: this.graph_id, country: this.country_id, product: this.product_id,
      plan: this.plan_id, sponsor: this.sponsor_id, user: this.user_id};
    } else {
      param = {graph_id: this.graph_id, country: this.country_id, symbol: symbol, product: this.product_id,
      provider: this.provider_id, sponsor: this.sponsor_id, category: this.category_id, 
      service: this.service_id, doctor: this.doctor_id, tdService: this.tdService_id};
    }

    this.filter.emit(param);
    this.styleFlag = false;
  }

  onSelectUser(user: any) {
    if (user !== null) {
      this.user_id = user.id;
    } else {
      this.user_id = null;
    }
    const ele = this.el.nativeElement.getElementsByClassName('ui-autocomplete-panel');
    ele[0].style.display = 'none';
  }

  onClearSelectUser() {
    this.user_id = null;
  }
  onSelectDoctor(doctor_id){
    if (doctor_id == 'null'){
      this.doctor_id = null
    }else{
      this.doctor_id = doctor_id;
    }
  }

  onSelectTDService(svc_id){
    if(svc_id == 'null'){
      this.tdService_id = null;
    }else{
      this.tdService_id = svc_id;
    }
  }
}
